import React from "react";
import Header from "./components/layout/Header";
import Hero from "./components/layout/Hero";
import About from "./components/sections/About";
import Services from "./components/sections/Services";
import Fleet from "./components/sections/Fleet";
import Partners from "./components/sections/Partners";
import Perks from "./components/sections/Perks";
import Quote from "./components/sections/Quote";
import Contact from "./components/sections/Contact";
import Footer from "./components/layout/Footer";
import { TranslationProvider } from "./context/TranslationContext";
import { RenderMap } from "./components/common/RenderMap";

function App() {
  return (
    <TranslationProvider>
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <Hero />
          <About />
          <Services />
          {/* Map Section */}
          <RenderMap />
          <Fleet />
          <Partners />
          {/* <Perks /> */}
          <Contact />
        </main>
        <Footer />
      </div>
    </TranslationProvider>
  );
}

export default App;
